import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const ButtonSpinner = props => {
    //Tomo los props
    const { hideText } = props;
    //Renderizo
    return (
        <Button variant="primary" disabled>
            <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true" />
                &nbsp; { hideText ? '' : 'Guardando...' }
        </Button>
    );
};

export default ButtonSpinner;